import React from 'react';
import './SkeletonHeroWrap.css'; // Custom CSS file for styling the skeletons

const SkeletonHeroWrap = () => {
  return (
    <section className="hero-wrap-skeleton">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Section */}
          <div className="col-lg-5">
            <div className="skeleton-text">
              <div className="skeleton-title" />
              <div className="skeleton-line" />
              <div className="skeleton-line short" />
              <div className="skeleton-button" />
            </div>
          </div>

          {/* Center Section - Image Placeholder */}
          <div className="col-lg-5">
            <div className="skeleton-image" />
          </div>

          {/* Right Section - Counters */}
          <div className="col-lg-2">
            <div className="skeleton-counter">
              <div className="skeleton-counter-box">
                <div className="skeleton-counter-number" />
                <div className="skeleton-counter-name" />
              </div>
              <div className="skeleton-counter-box">
                <div className="skeleton-counter-number" />
                <div className="skeleton-counter-name" />
              </div>
              <div className="skeleton-counter-box">
                <div className="skeleton-counter-number" />
                <div className="skeleton-counter-name" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SkeletonHeroWrap;
